import { motion } from "motion/react";
import { enter } from "../lib/motion";
import { toolLabel } from "../constants/toolLabels";

export function TypingIndicator({ tool }: { tool?: string }) {
  return (
    <motion.div
      {...enter}
      exit={{ opacity: 0, y: -4, transition: { duration: 0.18, ease: "easeOut" } }}
      className="flex items-center gap-2"
      aria-hidden
    >
      <span className="ca-thinking-shimmer text-[0.8125rem] font-medium">{toolLabel(tool)}</span>
      <span className="flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="size-1 animate-bounce rounded-full bg-primary/55 motion-reduce:animate-none"
            style={{ animationDelay: `${i * 0.15}s`, animationDuration: "0.9s" }}
          />
        ))}
      </span>
    </motion.div>
  );
}
